// withWindowWidth.js
import React from "react";
import { useWindowWidth } from "./index"; // 之前写的 Hook

export function withWindowWidth(Component) {
  return function Wrapper(props) {
    const width = useWindowWidth();
    return <Component {...props} windowWidth={width} />;
  };
}
